import useMenu from '../../hooks/useMenu'
import useSession from '../../hooks/useSession'

/**
 * Herramientas para validar los permisos para cada rol
 */
export default function useManagerPermission() {
    const { isWaiter, isDealer, isLogged } = useSession()
    const { initialMenu } = useMenu()

    function canWaiterOrDealarEdit(itemId: number) {
        if (!isWaiter() && !isDealer() && isLogged) return true
        /**
         * Si existe un item es porque se cargo inicialmente. Esto se carga en edición.
         */
        const existInitMenuItem = !!initialMenu.find(
            initMenuItem => initMenuItem.itemId === itemId
        )
        /**
         * Si existe entonces el mozo no podrá reducir o eliminar
         */
        return !existInitMenuItem
    }

    return {
        canWaiterOrDealarEdit
    }
}
